import { api_configuration } from "common";
import api_cs = api_configuration.types.client_state.alan_api;
import { orderedAttributes } from "../graphIterators";

export function nodeEditMode(node: api_cs.Cnode): ["on", Record<string, unknown>] | ["off", Record<string, unknown>] {
	switch (node.properties.location.state.name) {
		case "remote": {
			const $ = node.properties.location.state.node;
			switch ($.properties.edit_mode.state.name) {
				case "on":
					return ["on", {}];
				case "off":
					return ["off", {}];
				default:
					unexpectedState($.properties.edit_mode.state);
			}
			break;
		}
		case "local":
			return ["off", {}];
		default:
			unexpectedState(node.properties.location.state);
	}
}

export function switchOn(node: api_cs.Cnode): void {
	node.properties.location.switch({
		remote: ($) => {
			$.properties.edit_mode.ensure("on", {});
		},
		local: undefined,
	});
	const application_node = node.input.node_type();
	orderedAttributes(application_node).forEach(($) => {
		const attribute = node.properties.attributes.get($.key);
		if (attribute === undefined) {
			return;
		}
		attribute.properties.type.switch({
			operation: undefined,
			property: ($) =>
				$.properties.type.switch({
					collection: ($) => {
						$.properties.is_editable.switch({
							no: undefined,
							yes: ($) => {
								$.properties.edit_mode.ensure("on", {});
							},
						});
						$.properties.entries.forEach((entry) => switchOn(entry.properties.node));
					},
					file: ($) => {
						$.properties.is_editable.switch({
							no: undefined,
							yes: ($) => {
								$.properties.edit_mode.ensure("on", {});
							},
						});
					},
					group: ($) => {
						switchOn($.properties.node);
					},
					number: ($) => {
						$.properties.is_editable.switch({
							no: undefined,
							yes: ($) => {
								$.properties.edit_mode.ensure("on", {});
							},
						});
					},
					"state group": ($) => {
						stategroupOn($);
					},
					text: ($) => {
						textOn($);
					},
				}),
		});
	});
}

export function stategroupOn(stategroup: api_cs.Cstate_group__type__property) {
	stategroup.properties.is_editable.switch({
		no: undefined,
		yes: ($) => {
			$.properties.edit_mode.ensure("on", {});
		},
	});
	for (const state of stategroup.properties.states) {
		switchOn(state[1].properties.node);
	}
}

export function textOn(text: api_cs.Ctext__type__property) {
	text.properties.is_editable.switch({
		no: undefined,
		yes: ($) => {
			$.properties.edit_mode.ensure("on", {});
		},
	});
}

export function numberOn(number: api_cs.Cnumber__type__property) {
	number.properties.is_editable.switch({
		no: undefined,
		yes: ($) => {
			$.properties.edit_mode.ensure("on", {});
		},
	});
}

export function switchOff(node: api_cs.Cnode): void {
	node.properties.location.switch({
		remote: ($) => {
			$.properties.edit_mode.ensure("off", {});
		},
		local: undefined,
	});
	node.properties.attributes.forEach(($) =>
		$.properties.type.switch({
			operation: undefined,
			property: ($) =>
				$.properties.type.switch({
					collection: ($) => {
						$.properties.is_editable.switch({
							no: undefined,
							yes: ($) => {
								$.properties.edit_mode.ensure("off", {});
							},
						});
						$.properties.entries.forEach((entry) => switchOff(entry.properties.node));
					},
					file: (file_type) => {
						file_type.properties.is_editable.switch({
							no: undefined,
							yes: ($) => {
								file_type.properties.is_valid.switch({
									no: undefined,
									yes: () => {
										$.properties.edit_mode.ensure("off", {});
									},
								});
							},
						});
					},
					group: ($) => {
						switchOff($.properties.node);
					},
					number: (number_type) => {
						number_type.properties.is_editable.switch({
							no: undefined,
							yes: ($) => {
								number_type.properties.is_valid.switch({
									no: undefined,
									yes: () => {
										$.properties.edit_mode.ensure("off", {});
									},
								});
							},
						});
					},
					"state group": (state_group) => {
						state_group.properties.is_editable.switch({
							no: undefined,
							yes: ($) => {
								state_group.properties.is_valid.switch({
									no: undefined,
									yes: () => {
										$.properties.edit_mode.ensure("off", {});
									},
								});
							},
						});
						for (const state of state_group.properties.states) {
							switchOff(state[1].properties.node);
						}
					},
					text: (text_type) => {
						text_type.properties.is_editable.switch({
							no: undefined,
							yes: ($) => {
								text_type.properties.is_valid.switch({
									no: undefined,
									yes: () => {
										$.properties.edit_mode.ensure("off", {});
									},
								});
							},
						});
					},
				}),
		})
	);
}
